import React from "react";
import "./TrainingComp.css";
import trainingImg5 from "../../Images/trainingImg5.png";
import trainingImg6 from "../../Images/trainingImg6.webp";
import trainingImg7 from "../../Images/trainingImg7.jpg";

const CorporateTraining = () => {
  return (
    <div className="trainingCompSection">
      <h1>NSDC-Certified Internship</h1>
      <div className="trainingCompSection2">
        <div className="section2text">
          <h2>
            Build foundational skills with a government-recognized 1-month
            internship.
          </h2>
          <p>
            Our NSDC-certified internship program is designed to provide
            hands-on experience in high-demand tech domains. With a focus on
            practical learning and employability, this short-term training helps
            learners gain exposure to real-world tools and workflows.
            Participants receive certification from the National Skill
            Development Corporation (NSDC), boosting their credibility and
            career prospects.
          </p>
        </div>
        <div className="section2Img">
          <img src={trainingImg5} alt="trainingImg5" />
        </div>
      </div>
      <div className="trainingCardsBlock">
        <div className="trainingCards">
          <h3>Java Full Stack</h3>
          <p>
            Learn to build dynamic web applications using Java, Spring Boot, and
            front-end frameworks like Angular or React.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Web Development</h3>
          <p>
            Master HTML, CSS, JavaScript, and responsive design principles to
            create modern, user-friendly websites.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Python Full Stack</h3>
          <p>
            Develop full-stack applications using Python, Django/Flask, and
            front-end technologies with real-world project exposure.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Cyber Security</h3>
          <p>
            Understand the fundamentals of ethical hacking, network security,
            and data protection through hands-on labs and simulations.
          </p>
        </div>
      </div>
      <a href="/contact">
        <button>Apply</button>
      </a>
      <h1>Corporate Internship</h1>
      <div className="trainingCompSection2" id="aptitude">
        <div className="section2Img">
          <img src={trainingImg6} alt="trainingImg6" />
        </div>
        <div className="section2text">
          <h2>
            Hands-on experience with real-world projects and expert mentorship.
          </h2>
          <p>
            Our Corporate Internship program is designed for learners who want
            to gain practical exposure in high-demand tech domains. These
            internships simulate professional environments, allowing
            participants to work on live projects, collaborate with teams, and
            receive guidance from industry experts. Ideal for freshers and
            career switchers, this program builds confidence, technical fluency,
            and workplace readiness.
          </p>
        </div>
      </div>
      <div className="trainingCardsBlock">
        <div className="trainingCards">
          <h3>Web Development</h3>
          <p>
            Build responsive websites using HTML, CSS, JavaScript, and modern
            frameworks like React or Angular.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Java Development</h3>
          <p>
            Develop full-stack applications with Java, Spring Boot, and
            front-end technologies.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Data Analytics</h3>
          <p>
            Analyze data using Excel, SQL, and Python, and visualize insights
            with Power BI or Tableau.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Python Development</h3>
          <p>
            Create scalable applications using Python and frameworks like Django
            or Flask.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Cyber Security</h3>
          <p>
            Learn ethical hacking, network security, and threat analysis through
            hands-on labs.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Machine Learning</h3>
          <p>
            Work on ML models, data preprocessing, and algorithm implementation
            using Python.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Salesforce</h3>
          <p>
            Understand CRM workflows, automation, and app development on the
            Salesforce platform.
          </p>
        </div>
        <div className="trainingCards">
          <h3>AWS</h3>
          <p>
            Deploy and manage cloud applications using Amazon Web Services and
            DevOps tools.
          </p>
        </div>
      </div>
      <a href="/contact">
        <button>Apply</button>
      </a>
      <h1>Career Courses</h1>
      <div className="trainingCompSection2" id="aptitude">
        <div className="section2text">
          <h2>Comprehensive training for long-term career success.</h2>
          <p>
            Our Career Courses are intensive, 6-month programs that combine
            technical training, soft skills development, and placement support.
            These courses are ideal for learners who want to master a domain and
            become job-ready with a strong portfolio and certification. Each
            course includes mentorship, assessments, and real-world projects to
            ensure deep learning and career transformation.
          </p>
        </div>
        <div className="section2Img">
          <img src={trainingImg7} alt="trainingImg7" />
        </div>
      </div>
      <div className="trainingCardsBlock">
        <div className="trainingCards">
          <h3>Web Development</h3>
          <p>
            Full-stack training with front-end, back-end, and deployment skills
            for professional-grade websites.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Java Development</h3>
          <p>
            End-to-end development with Java, databases, APIs, and UI
            frameworks.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Data Analytics</h3>
          <p>
            Advanced analytics with Python, SQL, Excel, and visualization tools
            for business intelligence.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Python Development</h3>
          <p>
            Comprehensive Python programming for web, automation, and data
            applications.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Cyber Security</h3>
          <p>
            In-depth training in security protocols, penetration testing, and
            risk management.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Machine Learning</h3>
          <p>
            Project-based learning in supervised and unsupervised ML, model
            tuning, and deployment.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Salesforce</h3>
          <p>
            Master Salesforce development, automation, and integration for
            enterprise CRM solutions.
          </p>
        </div>
        <div className="trainingCards">
          <h3>AWS</h3>
          <p>
            Cloud architecture, services, and deployment strategies using AWS
            tools and best practices.
          </p>
        </div>
      </div>
      <a href="/contact">
        <button>Apply</button>
      </a>
    </div>
  );
};

export default CorporateTraining;
